module.exports = __webpack_public_path__ + "4f945b82b0b6d3d78eb55a8bd2055bda.svg";